require('./brokerNewsDetailsView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @utils
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');

// @components
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { ContentBox } = require('commonsComponents/contentBox');
const MoreNews = require('components/commons/broker/news/moreNews');
const { OKLink } = require('commonsComponents/OKLink');

// @commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');
const { EmptyState } = require('commonsComponents/emptyState');

// @actions
const newsActions = require('actions/brokerNews');

// @constants
const {
    DATETIME_FORMAT_ES,
    MYPROFILE_BROKER_URL
} = require('constants/index');

class BrokerNewsDetailsView extends React.Component {
    componentWillMount() {
        const { match: { params: { newsId } }, requestNewsById, newsToRequest } = this.props;
        requestNewsById(newsId, newsToRequest);
    }

    componentDidMount() {
        scrollToTop();
    }

    buildContent() {
        const { match: { params: { newsId } }, immBrokerNews } = this.props;

        const isFetching = immBrokerNews.get('isFetching');
        const isNotFound = immBrokerNews.getIn(['byId', newsId]) == null;
        const hasErrors = immBrokerNews.get('error');

        if (isFetching) {
            return this.buildLoadingContent();
        } else if (isNotFound || hasErrors) {
            return this.buildNotFoundNewContent();
        } else {
            return this.buildNewContent();
        }
    }

    buildLoadingContent() {
        return <LoadingSection />;
    }

    buildNotFoundNewContent() {
        return (
            <ContentBox id="brokerNewsDetailsView" customClassName="broker-news-details-view">
                <EmptyState
                    primaryText={formatText('broker-newsDetailsNotFound')}
                    iconType="noitems-wealth" />
            </ContentBox>
        );
    }

    buildNewContent() {
        const { match: { params: { newsId } }, immBrokerNews } = this.props;

        const id = immBrokerNews.getIn(['byId', newsId, 'id']);
        const date = immBrokerNews.getIn(['byId', newsId, 'date']);
        const title = immBrokerNews.getIn(['byId', newsId, 'titulo']);
        const summary = immBrokerNews.getIn(['byId', newsId, 'entradilla']);
        const body = immBrokerNews.getIn(['byId', newsId, 'cuerpo']);

        const objId = `brokerNewsDetail_${id}`;
        const formattedDate = DateHelper.buildFormattedDate(date, DATETIME_FORMAT_ES);

        return (
            <ContentBox id="brokerNewsDetailsView" customClassName="broker-news-details-view">
                <div key={objId} id={objId} className="broker-news-details-view">
                    <h3 className="broker-news-details-view__header-container">
                        <HTMLSafeInjector
                            inline
                            message={title}
                            customClass="news-title-container"
                        />
                    </h3>
                    <div className="news-details-underline" />
                    <span className="broker-news-details-view__date">
                        {formattedDate}
                    </span>
                    <HTMLSafeInjector
                        customClass="news-container"
                        message={summary}
                    />
                    <HTMLSafeInjector
                        customClass="news-container"
                        message={body}
                    />
                    <div className="pull-right">
                        <OKLink modifier="emphasize" to="/myprofile/broker/news">
                            <FormattedText value="broker-goBackToNews" />
                        </OKLink>
                    </div>
                </div>
            </ContentBox>
        );
    }

    buildBreadcrumb() {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerNews'),
                url: ''
            }
        ];
    }

    render() {
        const { immBrokerNews, requestNews } = this.props;

        const content = this.buildContent();
        const breadcrumb = this.buildBreadcrumb();

        const titleColumnLeftText = formatText('broker-newsDetailsTitle');

        return (
            <div className="broker-news-details-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={breadcrumb}
                        finalTitle={getFinalTitle('breadcrumb-brokerNews')}
                    />
                </OKCover>
                <section className="broker-news-details-view__body">
                    <div className="col-lg-8">
                        <div className="row no-outside-gutter">
                            {content}
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <ContentBox
                            title={titleColumnLeftText}
                            smallTitle={true}
                        >
                            <MoreNews
                                immBrokerNews={immBrokerNews}
                                requestNews={requestNews}
                            />
                        </ContentBox>
                    </div>
                    <div className="col-lg-12 broker-news-details-view__footer-disclaimer">
                        <div className="broker-news-details-view__disclaimer-paragraph">
                            <FormattedText value="broker-disclaimerTextFirstParagraph" />
                        </div>
                        <div className="broker-news-details-view__disclaimer-paragraph">
                            <FormattedText value="broker-disclaimerTextSecondParagraph" />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

BrokerNewsDetailsView.propTypes = {
    immBrokerNews: PropTypes.object,
    match: PropTypes.object.isRequired,
    requestNews: PropTypes.func.isRequired,
    requestNewsById: PropTypes.func.isRequired,
    newsToRequest: PropTypes.number
};

BrokerNewsDetailsView.defaultProps = {
    newsToRequest: 20
};

module.exports.constructor = BrokerNewsDetailsView;
module.exports.BrokerNewsDetailsView = connect(
    state => ({
        immBrokerNews: state.brokerNews
    }),
    {
        requestNews: newsActions.requestNews,
        requestNewsById: newsActions.requestNewsById,
    }
)(BrokerNewsDetailsView);
